import { Component } from '@angular/core';

import {
  IrisButtonContainerAlignments, IrisButtonTypes
} from '@sondermind/iris/button';
import { IrisModalRef } from '@sondermind/iris/modal';

@Component({
  selector: 'pending-changes-modal-modal',
  templateUrl: './pending-changes-modal.component.html',
  styleUrls: ['./pending-changes-modal.component.scss'],
  standalone: false
})
export class PendingChangesModalComponent {
  irisButtonContainerAlignments = IrisButtonContainerAlignments;
  irisButtonTypes = IrisButtonTypes;

  constructor(
    private irisModalRef: IrisModalRef<PendingChangesModalComponent, string, boolean>
  ) {}

  close(): void {
    this.irisModalRef.close(false);
  }

  closeWithoutSaving(): void {
    this.irisModalRef.close(true);
  }
}
